import { useState } from "react";

import { supabase } from "@/shared/lib/supabase";
import { uploadSupportingDocument } from "@/shared/utils/uploadSupportingDocument";

export function useUploadSupportingDocument() {
  const [isUploading, setIsUploading] = useState(false);

  const upload = async (file: File, estateId: number, documentType: string): Promise<number> => {
    setIsUploading(true);
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (!session) throw new Error("Not authenticated");
      return await uploadSupportingDocument(file, estateId, session.access_token, documentType);
    } finally {
      setIsUploading(false);
    }
  };

  return { upload, isUploading };
}
